import { render, staticRenderFns } from "./mastersTable.vue?vue&type=template&id=2663eb57&scoped=true"
import script from "./mastersTable.vue?vue&type=script&lang=js"
export * from "./mastersTable.vue?vue&type=script&lang=js"
import style0 from "./mastersTable.vue?vue&type=style&index=0&id=2663eb57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663eb57",
  null
  
)

export default component.exports